import { createAction } from 'redux-actions';

export const showDonate = createAction('SHOW_DONATE');
export const hideDonate = createAction('HIDE_DONATE');

export const hideDonateForever = createAction('HIDE_DONATE_FOREVER');
